import React from "react";
import DomainSearch from "../components/DomainSearch";
import DomainTransfer from "../components/DomainTransfer";
import { Globe2, ShieldCheck, RefreshCcw, Lock, Sparkles, Server } from "lucide-react";

const features = [
  { icon: Lock, title: "WHOIS Privacy", desc: "Keep your contact info private and protect against spam." },
  { icon: ShieldCheck, title: "Free SSL", desc: "Auto-installed SSL with every hosting plan." },
  { icon: RefreshCcw, title: "Easy Transfer", desc: "Transfer your existing domains to Optivize seamlessly." },
  { icon: Sparkles, title: "AI Suggestions", desc: "Get instant AI-powered domain name ideas." },
  { icon: Server, title: "Fast DNS", desc: "Cloudflare-backed global DNS for instant propagation." },
  { icon: Globe2, title: "150+ TLDs", desc: "From .com to .ai, .io, .dev, .store and more." },
];

export default function Domains() {
  return (
    <div>
      <section className="relative overflow-hidden">
        <div className="aurora" />
        <div className="absolute inset-0 grid-bg" />
        <div className="relative max-w-5xl mx-auto px-5 pt-20 pb-16 text-center">
          <div className="tag mb-4">Domains</div>
          <h1 className="text-5xl font-black tracking-tighter" style={{fontFamily:'Outfit'}}>
            Find your <span className="text-gradient-cyan">perfect domain</span>.
          </h1>
          <p className="text-gray-400 mt-3 max-w-xl mx-auto">Type a brand name and we'll check availability across the world's best TLDs in milliseconds.</p>
          <div className="mt-10"><DomainSearch /></div>
          <div className="mt-8 max-w-3xl mx-auto"><DomainTransfer /></div>
        </div>
      </section>

      <section className="section">
        <div className="grid md:grid-cols-3 gap-5">
          {features.map(f => (
            <div key={f.title} className="card p-6">
              <div className="w-11 h-11 rounded-lg bg-cyan-400/10 border border-cyan-400/20 flex items-center justify-center text-cyan-300 mb-4"><f.icon size={20}/></div>
              <h3 className="text-lg font-semibold text-white mb-1">{f.title}</h3>
              <p className="text-sm text-gray-400">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
